
import React from 'react'
import icon from './svgs/filter.svg'
import { BaseIcon } from './_base'

export const FilterIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
